"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flyout = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Dropdown = require("b2b-components/theme/components/Dropdown");
var _Body = require("./Body");
var _FlyoutWindow = require("./FlyoutWindow");
var _Heading = require("./Heading");
var _LinksGroup = require("./LinksGroup");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Flyout = function Flyout(_ref) {
  var className = _ref.className,
    dataAttributes = _ref.dataAttributes,
    label = _ref.label,
    onFlyoutOpen = _ref.onFlyoutOpen,
    renderContent = _ref.renderContent;
  var FlyoutWindow = Flyout.FlyoutWindow;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var togglerRef = (0, _react.useRef)(null);
  var setTogglerRef = function setTogglerRef(element) {
    return togglerRef.current = element;
  };
  var toggleFlyoutWindow = function toggleFlyoutWindow() {
    var nextIsOpen = !isOpen;
    setIsOpen(nextIsOpen);
    nextIsOpen && onFlyoutOpen && onFlyoutOpen();
  };
  var closeFlyoutWindow = function closeFlyoutWindow() {
    return setIsOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown.Toggler, {
    label: label,
    onClick: toggleFlyoutWindow,
    styleType: _Dropdown.Dropdown.Toggler.config.styleType.button,
    className: className,
    dataAttributes: dataAttributes,
    setRef: setTogglerRef
  }), isOpen && /*#__PURE__*/_react["default"].createElement(FlyoutWindow, {
    closeFlyoutWindow: closeFlyoutWindow,
    renderContent: renderContent,
    togglerRef: togglerRef
  }));
};
exports.Flyout = Flyout;
Flyout.FlyoutWindow = _FlyoutWindow.FlyoutWindow;
Flyout.Body = _Body.Body;
Flyout.Heading = _Heading.Heading;
Flyout.LinksGroup = _LinksGroup.LinksGroup;